import { Component, ViewChild, OnInit, EventEmitter, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CompetenciesService } from '../competencies.service';
import { Partnership, PartnershipCreationComponentComponent } from '../competency/partnership-creation-component/partnership-creation-component.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-partnership-grid',
  templateUrl: './partnership-grid.component.html',
  styleUrls: ['./partnership-grid.component.css']
})
export class PartnershipGridComponent implements OnInit {
  isEditMode: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @Output() actionId: EventEmitter<any> = new EventEmitter();

  displayedColumns: string[] = ['name', 'description', 'type', 'logo', 'actions'];
  dataSource: MatTableDataSource<Partnership>;
  formGroup: FormGroup;
  partnershipsList: Partnership[] = [];

  constructor(
    private compservice: CompetenciesService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,

  ) {
    this.dataSource = new MatTableDataSource([]);
    this.formGroup = this.formBuilder.group({
      id: [''],
      logo: [''],
      name: [''],
      type: [''],
      description: ['']
    });
  }

  ngOnInit() {
    this.fetchData();
  }

  toggleEditMode() {
    this.isEditMode = !this.isEditMode;
  }

  fetchData() {
    this.compservice.getPartnershipdetails().subscribe(
      response => {
        if (response && response.data) {
          this.dataSource.data = response.data;
          this.dataSource.sort = this.sort;
        }
      },
      error => {
        console.error('Error fetching partnership details:', error);
      }
    );
  }

  deleteRecord(id: string) {
    this.compservice.deletePartnershipdetails(id).subscribe(
      response => {
        this.toastr.error("Partnership deleted successfully");
        console.log('Record deleted successfully:', response);

        const deletedIndex = this.dataSource.data.findIndex(item => item.id === id);
        if (deletedIndex !== -1) {
          this.dataSource.data.splice(deletedIndex, 1);
          this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
      },
      error => {
        console.error('Error deleting record:', error);
      }
    );
  }

  addTemplate() {
    const dialogRef: MatDialogRef<PartnershipCreationComponentComponent> = this.dialog.open(PartnershipCreationComponentComponent, {
      width: '550px',
      height: '350px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.partnershipsList.push(result);
        this.fetchData();
      }
    });
  }

  populateFormFields(record: any) {
    this.formGroup.patchValue({
      logo: record.logo,
      name: record.name,
      type: record.type,
      description: record.description
    });
  }

  editRecord(rowId: string) {
    this.compservice.getPartnershipdetails().subscribe(response => {
      if (response.data) {
        const record = response.data.find(item => item.id === rowId);
        if (record) {
          const dialogRef = this.dialog.open(PartnershipCreationComponentComponent, {
            width: '550px',
            height: '350px',
            data: record
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              window.location.reload();
              this.fetchData();
            }
          });
        } else {
          console.error('Record with ID', rowId, 'not found.');
        }
      } else {
        console.error('Error fetching partnership details.');
      }
    });
  }

}
